<template>
  <div class="bg-gray-300 w-full min-h-full relative">
    <HomeNavigation />
    <UIHomepageBackButton />

    <div class="w-full h-full text-secondary-dark flex flex-col">
      <div class="w-full h-400 title-background bg-cover laptop:min-h-1/2">
        <div
          class="background-opacity w-full h-full flex flex-col items-center align-center
          justify-center px-20"
        >
          <h1 class="text-4xl text-white leading-tight mb-20 tablet:text-5xl">
            {{ $t('price_list_view.price_intro_title_text') }}
          </h1>
          <h2 class="text-gray-400">
            {{ $t('price_list_view.price_intro_subtitle_text') }}
          </h2>
        </div>
      </div>
      <div class="w-full h-full flex align-center justify-center">
        <div class="w-full h-full flex flex-col justify-center laptop:flex-row">
          <div class="w-full p-30 laptop:w-600">
            <p class="text-3xl mb-20">{{ $t('price_list_view.buyer_text') }}</p>
            <div class="flex flex row mb-10">
              <div class="w-2/3 flex flex-col">
                <p class="text-xl">{{ $t('price_list_view.free_auto_drop_text') }}</p>
                <p class="text-sm">{{ $t('price_list_view.free_auto_drop_subtitle_text') }}</p>
              </div>
              <p class="w-1/3 text-xl text-center text-primary">
                {{ $t('price_list_view.free_text') }}
              </p>
            </div>
            <div class="flex flex row">
              <div class="flex flex-col">
                <p class="text-xl">{{ $t('price_list_view.whatsapp_title_text') }}</p>
                <p class="text-sm">{{ $t('price_list_view.whatsapp_subtitle_first_text') }} CHF {{ $t('price_list_view.whatsapp_subtitle_last_text') }}</p>
              </div>
            </div>
          </div>
          <div class="w-full p-30 laptop:w-600">
            <p class="text-3xl mb-20">{{ $t('price_list_view.seller_text') }}</p>
            <div class="flex flex row mb-10">
              <div class="w-2/3 flex flex-col">
                <p class="text-xl leading-tight">
                  {{ $t('price_list_view.upload_vehicle_title_text') }}
                </p>
                <p class="text-sm">{{ $t('price_list_view.upload_vehicle_subtitle_text') }}</p>
              </div>
              <p class="w-1/3 text-xl text-center text-primary">40 CHF</p>
            </div>
            <div class="flex flex row mb-10">
              <div class="w-2/3 flex flex-col">
                <p class="text-xl">{{ $t('price_list_view.sms_fee_title_text') }}</p>
                <p class="text-sm">{{ $t('price_list_view.sms_fee_subtitle_text') }}</p>
              </div>
              <p class="w-1/3 text-xl text-center text-primary">0.28 CHF</p>
            </div>
            <div class="flex flex row mb-10">
              <div class="w-2/3 flex flex-col">
                <p class="text-xl">{{ $t('price_list_view.logo_title_text') }}</p>
                <p class="text-sm">{{ $t('price_list_view.logo_subtitle_text') }}</p>
              </div>
              <p class="w-1/3 text-xl text-center text-primary">300 CHF</p>
            </div>
            <div class="flex flex row mb-10">
              <div class="w-2/3 flex flex-col">
                <p class="text-xl leading-tight">
                  {{ $t('price_list_view.own_sender_name_title_text') }}
                </p>
                <p class="text-sm leading-tight">
                  {{ $t('price_list_view.own_sender_name_subtitle_first_text') }} CHF {{ $t('price_list_view.own_sender_name_subtitle_last_text') }}
                </p>
              </div>
              <p class="w-1/3 text-xl text-center text-primary">100 CHF</p>
            </div>
            <div class="flex flex row">
              <p class="pt-10 text-sm">{{ $t('price_list_view.monthly_bill_explanation_text') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="m-auto px-20 pt-40">
        <p>
          {{ $t('price_list_view.more_questions_text') }}
        </p>
        <p>
          {{ $t('price_list_view.phone_text') }}:
          <a
            href="tel:+41 32 511 10 44"
            class="font-medium"
          >+41 32 511 10 44</a>
        </p>
        <p>
          Email:
          <a
            href="mailto:info@autodrop.ch"
            class="font-medium"
          >info@autodrop.ch</a>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import HomeNavigation from '@/components/HomeNavigation';
import UIHomepageBackButton from '@/components/UI-old/UIHomepageBackButton';


export default {
  components: {
    HomeNavigation,
    UIHomepageBackButton,
  },
};
</script>


<style scoped>
.background-opacity {
  background: rgba(0, 0, 0, 0.8);
}
.title-background {
  background-image: url("/images/autodrop/pricing-bg.jpg");
}
</style>
